import { ChevronLeft, ChevronRight } from '@styled-icons/boxicons-regular'
import useFetch from 'hooks/useFetch'
import { translate } from 'locales/index'
import { orderBy } from 'lodash'
import { format } from 'date-fns'
import { formatLocal, formatLocalCap, formatUTC } from 'utils/date'
import { isStartPlan } from 'utils/plan'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { useUser } from 'context/user/user.context'

import {
  Footer,
  Header,
  Loading,
  ReminderAlert,
  TotalPassMetricInfo,
} from 'components'

import icon1 from 'assets/icons/1.svg'
import icon2 from 'assets/icons/2.svg'
import icon3 from 'assets/icons/3.svg'
import icon4 from 'assets/icons/4.svg'

import { IDashMetrics } from './Interfaces'
import { findDashMetrics } from './services'
import * as S from './styles'

import { findUserData, schedulingListFormated } from '../Home/services'
import { psicoName } from '../Home/utils'

const Dash = () => {
  const history = useHistory()
  const { setUserData } = useUser()

  const [period, setPeriod] = useState<{ month: number; year: number }>({
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  })

  const [metricsLoading, setMetricsLoading] = useState(false)
  const [metrics, setMetrics] = useState<IDashMetrics>({
    doctor_id: '',
    total: '0',
    total_tp: '0',
    pending: '0',
    pending_tp: '0',
    started: '0',
    started_tp: '0',
    finished: '0',
    finished_tp: '0',
    finished_60: '0',
    finished_60_tp: '0',
    noshow: '0',
    noshow_tp: '0',
    noshow_60: '0',
    noshow_60_tp: '0',
    canceled_by_30_min: '0',
    canceled_by_30_min_tp: '0',
    canceled_60_by_30_min: '0',
    canceled_60_by_30_min_tp: '0',
    canceled: '0',
    canceled_tp: '0',
    slots_occupied: '0',
    slots_total: '0',
  })

  const dataInStorage: any = window.localStorage.getItem('@StarBem:user')
  const dataParse = JSON.parse(dataInStorage)

  const today = format(new Date(), 'yyyy-MM-dd')
  const { data, isLoading } = useFetch({
    url: `schedulings/ms/v1/doctor/${dataParse.id}/all?start=${today}&end=${today}`,
    options: {
      refreshInterval: 1000 * 60 * 2,
    },
  })
  const hasPsicologo = dataParse?.specialties.some(
    (specialty: any) => specialty.slug === 'psicologo'
  )

  const { data: slotsVerification } = useFetch({
    url: `schedule/v1/schedules/verify-quantity-slots?user_id=${dataParse.id}`,
    options: {
      revalidateOnMount: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const { data: doctorData } = useFetch({
    url: 'doctors/ms/v1/me',
    options: {
      revalidateOnMount: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  })

  const isTotalPassAllowed = !isStartPlan(doctorData?.categories?.name)

  const findAll = async () => {
    await findUserData(setUserData)
  }

  useEffect(() => {
    findAll()
  }, [])

  const handleAppointmentSelection = (
    appointmentId: string,
    areaName: string
  ) => {
    if (psicoName.includes(areaName)) {
      const area = String(areaName).normalize('NFD').toLowerCase()
      history.push(`/${area}/novo-prontuario/${appointmentId}`)
    } else {
      history.push(`/novo-prontuario/${appointmentId}`)
    }
  }

  const addPeriod = () => {
    if (period.month < 12) {
      setPeriod({
        ...period,
        month: period.month + 1,
      })
    } else if (period.month === 12) {
      setPeriod({
        ...period,
        month: 1,
        year: period.year + 1,
      })
    }
  }

  const subPeriod = () => {
    if (period.month > 1) {
      setPeriod({
        ...period,
        month: period.month - 1,
      })
    } else if (period.month === 1) {
      setPeriod({
        ...period,
        month: 12,
        year: period.year - 1,
      })
    }
  }

  useEffect(() => {
    const monthFormatted = `${period.year}-${String(period.month).padStart(2, '0')}`
    findDashMetrics(setMetrics, monthFormatted, setMetricsLoading)
  }, [period])

  const todayPatients = schedulingListFormated(data).todayPatientsList

  return (
    <S.Container>
      {(isLoading || metricsLoading) && (
        <Loading title={translate('dash.loading')} />
      )}
      <Header />

      <S.Content>
        <S.Title>{translate('dash.title')}</S.Title>

        <S.GridContainer container>
          <S.LeftSection>
            <S.CardContainer>
              <S.SectionTitle>{translate('dash.patientsToday')}</S.SectionTitle>
              <S.PatientsList>
                {todayPatients.length === 0 ? (
                  <S.EmptyState>
                    {translate('home.notScheduleToday')}
                  </S.EmptyState>
                ) : (
                  orderBy(todayPatients, ['date'], ['asc']).map((item: any) => (
                    <S.PatientCard
                      key={item?.uuid}
                      onClick={() =>
                        handleAppointmentSelection(item?.uuid, item?.slug)
                      }
                    >
                      <span className="name">{item?.name}</span>
                      <span className="time">
                        {formatUTC(item?.date, 'HH:mm')}
                      </span>
                    </S.PatientCard>
                  ))
                )}
              </S.PatientsList>
            </S.CardContainer>
          </S.LeftSection>

          <S.RightSection>
            {slotsVerification?.quantity < 60 && (
              <ReminderAlert
                title={translate('home.reminderTitle')}
                description={translate('home.reminderDescription')}
                onClick={() => history.push('/configurar-agenda')}
              />
            )}
            <S.CardContainer>
              <S.DashboardHeader>
                <S.SectionTitle style={{ marginBottom: 0 }}>
                  {translate('dash.myDashboard')}
                </S.SectionTitle>
                <S.PeriodSelector>
                  <button type="button" onClick={subPeriod}>
                    <ChevronLeft size={24} color="#666" />
                  </button>
                  <span>
                    {formatLocalCap(
                      new Date(period.year, period.month - 1),
                      'MMM/yyyy'
                    )}
                  </span>
                  <button
                    type="button"
                    onClick={addPeriod}
                    disabled={
                      period.month === new Date().getMonth() + 1 &&
                      period.year === new Date().getFullYear()
                    }
                  >
                    <ChevronRight size={24} color="#666" />
                  </button>
                </S.PeriodSelector>
              </S.DashboardHeader>

              <S.MetricsGrid>
                <S.MetricCard>
                  <div className="top-row">
                    <div className="info">
                      <span className="label">
                        {translate('dash.inProgress')}
                      </span>
                      <span className="value">{metrics.slots_occupied}</span>
                    </div>
                    <div className="icon-wrapper">
                      <img src={icon4} alt={translate('dash.inProgress')} />
                    </div>
                  </div>
                </S.MetricCard>

                <S.MetricCard highlighted={slotsVerification?.quantity < 60}>
                  <div className="top-row">
                    <div className="info">
                      <span className="label">
                        {translate('dash.openSchedules')}
                      </span>
                      <span className="value">{metrics.slots_total}</span>
                    </div>
                    <div className="icon-wrapper">
                      <img src={icon2} alt={translate('dash.openSchedules')} />
                    </div>
                  </div>
                </S.MetricCard>

                <S.MetricCard>
                  <div className="top-row">
                    <div className="info">
                      <span className="label">{translate('dash.started')}</span>
                      <span className="value">{metrics.started}</span>
                    </div>
                    <div className="icon-wrapper">
                      <img src={icon4} alt={translate('dash.started')} />
                    </div>
                  </div>
                  <TotalPassMetricInfo
                    total={Number(metrics.started) || 0}
                    totalPassCount={Number(metrics.started_tp) || 0}
                    visible={isTotalPassAllowed}
                  />
                </S.MetricCard>

                <S.MetricCard>
                  <div className="top-row">
                    <div className="info">
                      <span className="label">
                        {hasPsicologo
                          ? translate('dash.finished30min')
                          : translate('dash.finished')}
                      </span>
                      <span className="value">{metrics.finished}</span>
                    </div>
                    <div className="icon-wrapper">
                      <img src={icon1} alt={translate('dash.finished30min')} />
                    </div>
                  </div>
                  <TotalPassMetricInfo
                    total={Number(metrics.finished) || 0}
                    totalPassCount={Number(metrics.finished_tp) || 0}
                    visible={isTotalPassAllowed}
                  />
                </S.MetricCard>

                {hasPsicologo && (
                  <S.MetricCard>
                    <div className="top-row">
                      <div className="info">
                        <span className="label">
                          {translate('dash.finished60min')}
                        </span>
                        <span className="value">{metrics.finished_60}</span>
                      </div>
                      <div className="icon-wrapper">
                        <img
                          src={icon1}
                          alt={translate('dash.finished60min')}
                        />
                      </div>
                    </div>
                    <TotalPassMetricInfo
                      total={Number(metrics.finished_60) || 0}
                      totalPassCount={Number(metrics.finished_60_tp) || 0}
                      visible={isTotalPassAllowed}
                    />
                  </S.MetricCard>
                )}

                <S.MetricCard>
                  <div className="top-row">
                    <div className="info">
                      <span className="label">
                        {translate('dash.canceled')}
                      </span>
                      <span className="value">{metrics.canceled}</span>
                    </div>
                    <div className="icon-wrapper">
                      <img src={icon3} alt={translate('dash.canceled')} />
                    </div>
                  </div>
                  <TotalPassMetricInfo
                    total={Number(metrics.canceled) || 0}
                    totalPassCount={Number(metrics.canceled_tp) || 0}
                    visible={isTotalPassAllowed}
                  />
                </S.MetricCard>

                <S.MetricCard>
                  <div className="top-row">
                    <div className="info">
                      <span className="label">
                        {hasPsicologo
                          ? translate('dash.canceledLess30min')
                          : translate('dash.canceled30min')}
                      </span>
                      <span className="value">
                        {metrics.canceled_by_30_min}
                      </span>
                    </div>
                    <div className="icon-wrapper">
                      <img
                        src={icon3}
                        alt={translate('dash.canceledLess30min')}
                      />
                    </div>
                  </div>
                  <TotalPassMetricInfo
                    total={Number(metrics.canceled_by_30_min) || 0}
                    totalPassCount={Number(metrics.canceled_by_30_min_tp) || 0}
                    visible={isTotalPassAllowed}
                  />
                </S.MetricCard>

                {hasPsicologo && (
                  <S.MetricCard>
                    <div className="top-row">
                      <div className="info">
                        <span className="label">
                          {translate('dash.canceledLess30min60')}
                        </span>
                        <span className="value">
                          {metrics.canceled_60_by_30_min}
                        </span>
                      </div>
                      <div className="icon-wrapper">
                        <img
                          src={icon3}
                          alt={translate('dash.canceledLess30min60')}
                        />
                      </div>
                    </div>
                    <TotalPassMetricInfo
                      total={Number(metrics.canceled_60_by_30_min) || 0}
                      totalPassCount={
                        Number(metrics.canceled_60_by_30_min_tp) || 0
                      }
                      visible={isTotalPassAllowed}
                    />
                  </S.MetricCard>
                )}

                <S.MetricCard>
                  <div className="top-row">
                    <div className="info">
                      <span className="label">
                        {hasPsicologo
                          ? translate('dash.noShow30min')
                          : translate('dash.noShow')}
                      </span>
                      <span className="value">{metrics.noshow}</span>
                    </div>
                    <div className="icon-wrapper">
                      <img src={icon3} alt={translate('dash.noShow30min')} />
                    </div>
                  </div>
                  <TotalPassMetricInfo
                    total={Number(metrics.noshow) || 0}
                    totalPassCount={Number(metrics.noshow_tp) || 0}
                    visible={isTotalPassAllowed}
                  />
                </S.MetricCard>

                {hasPsicologo && (
                  <S.MetricCard>
                    <div className="top-row">
                      <div className="info">
                        <span className="label">
                          {translate('dash.noShow60min')}
                        </span>
                        <span className="value">{metrics.noshow_60}</span>
                      </div>
                      <div className="icon-wrapper">
                        <img src={icon3} alt={translate('dash.noShow60min')} />
                      </div>
                    </div>
                    <TotalPassMetricInfo
                      total={Number(metrics.noshow_60) || 0}
                      totalPassCount={Number(metrics.noshow_60_tp) || 0}
                      visible={isTotalPassAllowed}
                    />
                  </S.MetricCard>
                )}
              </S.MetricsGrid>
            </S.CardContainer>
          </S.RightSection>
        </S.GridContainer>
      </S.Content>

      <Footer />
    </S.Container>
  )
}

export default Dash
